import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-mute",
  "use": "icon-mute-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-mute\">\n\t<path fill=\"none\" d=\"M0,0H24V24H0Z\" /> \n\t<path d=\"M20.27,12,24,15.68l-1.48,1.48L18.8,13.47l-3.69,3.69-1.47-1.48L17.33,12,13.64,8.32l1.47-1.48,3.69,3.69,3.68-3.69L24,8.32ZM5.14,16.17h-4a1,1,0,0,1-1-1V8.87a1,1,0,0,1,1.05-1H5.14l5.51-4.51a.52.52,0,0,1,.56-.07.53.53,0,0,1,.3.47V20.28a.53.53,0,0,1-.3.47.52.52,0,0,1-.56-.07L5.14,16.17ZM9.42,7,5.88,9.92H2.13v4.16H5.88L9.42,17Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol